import { Location } from '@angular/common';
import { Component, DoCheck, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ProcessErrorCode } from 'src/app/ajs-upgraded-providers';

import { CompanyApiService } from 'src/app/api/services/company-api.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { ActionsMenu } from 'src/app/components/common-actions/common-actions.component';
import { TrackerService } from 'src/app/components/logging/tracker.service';
import { BaseEditableComponent } from 'src/app/shared/components/base-editable/base-editable.component';
import { AddressService } from 'src/app/shared/services/address.service';
import { MoveCompanyComponent } from '../move-company/move-company.component';
@Component({
    selector: 'company-add',
    templateUrl: './company-add.component.html',
    styleUrls: ['./company-add.component.scss'],
    standalone: false
})
export class CompanyAddComponent
  extends BaseEditableComponent<any>
  implements DoCheck {

  company = {};
  loading = false;
  formError = null;
  apiError = null;
  isAddressError = false;

  @ViewChild('companyForm')
  public companyForm: NgForm;

  actions: ActionsMenu = {
    saveAction: {
      id: 'saveButton',
      label: 'Save',
      action: () => this.save(),
      requireRole: 'ua sa',
      disabled: false
    },
    cancelAction: {
      id: 'cancelButton',
      label: 'Cancel',
      action: () => this.cancel()
    },
    moreOptions: [{
      id: 'moveButton',
      label: 'Move a Company Under Your Company',
      action: () => this.moveCompany()
    }]
  };

  constructor(private _location: Location,
    private companyStateService: CompanyStateService,
    private companyApiService: CompanyApiService,
    private addressFactory: AddressService,
    private tracker: TrackerService,
    private processErrorCode: ProcessErrorCode
  ) {
    super();
  }

  ngDoCheck(): void {
    if (this.companyForm && !this.oldObject) {
      this.oldObject = this.cloneDeep(this.companyForm.form.value);
    }
  }

  canDeactivate(): boolean {
    console.log(this.company, this.oldObject);
    return this.isDeepEqual(this.oldObject, this.companyForm.form.value);
  }

  save() {
    this._clearErrorMessages();

    if (!this.companyForm.valid) {
      console.log('Form not valid');
    } else {
      this.loading = true;

      this.addressFactory.validateAddressIfChanged(this.companyForm.form.controls, this.company)
        .then(() => {
          this.companyApiService.createCompany(this.companyStateService.getSelectedCompanyId(), this.company)
            .then((company) => {
              this.tracker.companyEvent('Company Created', company.id, company.name);

              this.companyStateService.switchCompany(company.id).then(() => {
                this.bypassUnsavedChanges();
                this.stateService.go('apps.settings.company-details', { cid: company.id });
              });

            })
            .catch((err) => {
              this.formError = 'Failed to Add Sub-Company.';
              this.apiError = this.processErrorCode(err);
            })
            .finally(() => {
              this.loading = false;
            });

        })
        .catch((error) => {
          this.loading = false;

          this.formError = 'We couldn\'t update your address.';
          this.apiError = this.processErrorCode(error);
          this.isAddressError = true;
        });
    }
  }

  // Show Move Company Modal
  moveCompany() {
    return this.modalService.showMediumDialog(
      MoveCompanyComponent,
      null,
      null,
      'moveButton'
    );
  }

  _clearErrorMessages() {
    this.formError = null;
    this.apiError = null;
    this.isAddressError = false;
  }

  cancel() {
    this.bypassUnsavedChanges();
    this._location.back();
  }

}
